// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchAmenitiesTable, fetchAmenities, fetchAmenityById, addAmenity, updateAmenity, removeAmenity } from "../../api/amenityApi";

// Async thunks for amenity operations

export const getAmenities = createAsyncThunk(
  "amenity/getAmenities",
  async ({ page, limit }: { page: number; limit: number }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchAmenitiesTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAmenityById = createAsyncThunk(
  "amenity/getAmenityById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchAmenityById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createAmenity = createAsyncThunk(
  "amenity/createAmenity",
  async (newAmenity: { name: string; description: string; popular: boolean; is_more: boolean; photo?: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addAmenity(newAmenity);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editAmenity = createAsyncThunk(
  "amenity/editAmenity",
  async ({ id, updatedAmenity }: { id: string; updatedAmenity: { name: string; description: string; popular: boolean; is_more: boolean; photo?: string } }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updateAmenity(id, updatedAmenity);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAmenity = createAsyncThunk(
  "amenity/deleteAmenity",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeAmenity(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Amenity Slice

const amenitySlice = createSlice({
  name: "amenity",
  initialState: {
    amenities: [] as any[],
    amenity: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all amenities
      .addCase(getAmenities.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.amenities = action.payload;
      })
      .addCase(getAmenities.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Get amenity by ID
      .addCase(getAmenityById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.amenity = action.payload;
      })
      .addCase(getAmenityById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Create amenity
      .addCase(createAmenity.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(action.payload)) {
          state.amenities.push(action.payload);
          state.status = true;
          state.msg = "Amenity created successfully.";
        } else {
          console.log('amenity not an array');
        }
      })
      
      // Edit amenity
      .addCase(editAmenity.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.amenities)) {
          const index = state.amenities.findIndex((amenity) => amenity.id === id);
          if (index !== -1) {
            state.amenities[index] = data;
          }
          state.status = true;
          state.msg = "Amenity updated successfully.";
        } else {
          console.log('amenity not an array');
        }
      })
      
      // Delete amenity
      .addCase(deleteAmenity.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.amenities)) {
          state.amenities = state.amenities.filter((amenity) => amenity.id !== action.payload);
          state.status = true;
          state.msg = "Amenity deleted successfully.";
        } else {
          console.log('amenity not an array');
        }
      });
  },
});

export const { resetStatus } = amenitySlice.actions;
export default amenitySlice.reducer;
